"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.DEFAULT_API_CONFIG=void 0;/**
 * The default configuration for the app.
 */var DEFAULT_API_CONFIG={url:process.env.REACT_APP_API_GATEWAY_ADDRESS||"",timeout:30000,apiPageSize:50};exports.DEFAULT_API_CONFIG=DEFAULT_API_CONFIG;